import { Box, Button, Container, Grid, Stack, Typography, useTheme, alpha } from '@mui/material';
import { Link } from 'react-router-dom';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { moduleColors } from '../../theme';
import Reveal from '../ui/Reveal';

const points = [
  'No monthly fee — pay only per successful payment',
  'Under 5,000 ALL: 50 ALL flat · 5,000 ALL and above: 2% + 20 ALL',
  'Hosted page at connect.solvenda.org, synced with Solvenda',
];

const ConnectStrip = () => {
  const theme = useTheme();
  const green = moduleColors.connect;

  return (
    <Box sx={{ py: { xs: 6, md: 9 }, bgcolor: 'background.default' }}>
      <Container>
        <Reveal>
          <Box
            sx={{
              borderRadius: 4,
              p: { xs: 4, md: 6 },
              border: `1px solid ${alpha(green, 0.35)}`,
              background: `linear-gradient(135deg, ${alpha(green, theme.palette.mode === 'dark' ? 0.16 : 0.1)}, ${alpha(green, 0.02)})`,
            }}
          >
            <Grid container spacing={4} alignItems="center">
              <Grid item xs={12} md={7}>
                <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 2 }}>
                  <Box
                    sx={{
                      width: 48,
                      height: 48,
                      borderRadius: 2,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: green,
                      bgcolor: alpha(green, 0.16),
                    }}
                  >
                    <CreditScoreIcon />
                  </Box>
                  <Typography variant="h3" component="h2">
                    SolvendaConnect
                  </Typography>
                </Stack>
                <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 2 }}>
                  Let your subscribers pay online by credit or debit card. Free for
                  every provider — we only take a small fee per successful payment.
                </Typography>
                <Stack spacing={1}>
                  {points.map((p) => (
                    <Typography key={p} variant="body2" sx={{ color: 'text.secondary' }}>
                      • {p}
                    </Typography>
                  ))}
                </Stack>
              </Grid>
              <Grid item xs={12} md={5}>
                <Stack spacing={2} sx={{ alignItems: { xs: 'stretch', md: 'flex-end' } }}>
                  <Button
                    component="a"
                    href="https://connect.solvenda.org"
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="contained"
                    color="secondary"
                    size="large"
                    endIcon={<ArrowForwardIcon />}
                  >
                    Go to payment portal
                  </Button>
                  <Button component={Link} to="/connect" variant="text" color="secondary" size="large">
                    Learn how it works
                  </Button>
                </Stack>
              </Grid>
            </Grid>
          </Box>
        </Reveal>
      </Container>
    </Box>
  );
};

export default ConnectStrip;
